interface Expense {
  label: string,
  type: string,
  value: number,
  otherExpense: boolean
}

export class ConstsProvider {

  public esperanzaDeVida = [
    { "edad": 15, "imssh": 393.557303275739, "imssm": 396.768780110935, "privada": 297.020065486932, "esperanzaH": 63.6146150534455, "esperanzaM": 71.9054817085094 },
    { "edad": 16, "imssh": 393.557303275739, "imssm": 396.768780110935, "privada": 295.698848011949, "esperanzaH": 62.7224977495748, "esperanzaM": 70.970774821345 },
    { "edad": 17, "imssh": 393.557303275739, "imssm": 396.768780110935, "privada": 294.34389174482, "esperanzaH": 61.8319402838773, "esperanzaM": 70.0352072119801 },
    { "edad": 18, "imssh": 393.557303275739, "imssm": 396.768780110935, "privada": 292.952144142673, "esperanzaH": 60.9422457486824, "esperanzaM": 69.0987780878209 },
    { "edad": 19, "imssh": 392.219237828008, "imssm": 395.512867889766, "privada": 291.524421413314, "esperanzaH": 60.0539460884068, "esperanzaM": 68.1621689049024 },
    { "edad": 20, "imssh": 390.83756036465, "imssm": 394.214320110136, "privada": 290.059578041059, "esperanzaH": 59.1669549724041, "esperanzaM": 67.2246878646165 },
    { "edad": 21, "imssh": 389.410942686367, "imssm": 392.871566117886, "privada": 288.558385930591, "esperanzaH": 58.2817700594212, "esperanzaM": 66.2863341553811 },
    { "edad": 22, "imssh": 387.937642341679, "imssm": 391.483182879329, "privada": 287.017793826664, "esperanzaH": 57.3977134405711, "esperanzaM": 65.3471069648584 },
    { "edad": 23, "imssh": 386.416712225308, "imssm": 390.048476424357, "privada": 285.440323886124, "esperanzaH": 56.5158315284656, "esperanzaM": 64.407650156005 },
    { "edad": 24, "imssh": 384.846326454304, "imssm": 388.564971159449, "privada": 283.82292761436, "esperanzaH": 55.635447741109, "esperanzaM": 63.4673094268663 },
    { "edad": 25, "imssh": 383.224935543962, "imssm": 387.031981094649, "privada": 282.166232374442, "esperanzaH": 54.757008299534, "esperanzaM": 62.5267098011774 },
    { "edad": 26, "imssh": 381.551601373284, "imssm": 385.446911090787, "privada": 280.470782920595, "esperanzaH": 53.8809344487661, "esperanzaM": 61.5852157561457 },
    { "edad": 27, "imssh": 379.824026707434, "imssm": 383.808978526627, "privada": 278.733533341309, "esperanzaH": 53.0065599959565, "esperanzaM": 60.6434334522599 },
    { "edad": 28, "imssh": 378.0413267565, "imssm": 382.115567985005, "privada": 276.956805556653, "esperanzaH": 52.1348116325727, "esperanzaM": 59.7007461685817 },
    { "edad": 29, "imssh": 376.201094786674, "imssm": 380.365583071231, "privada": 275.137587965636, "esperanzaH": 51.2650247955534, "esperanzaM": 58.7577411775239 },
    { "edad": 30, "imssh": 374.302334089195, "imssm": 378.557195109932, "privada": 273.278090178159, "esperanzaH": 50.3980757154421, "esperanzaM": 57.814399288827 },
    { "edad": 31, "imssh": 372.343019023268, "imssm": 376.688515317157, "privada": 271.376983017795, "esperanzaH": 49.5337983228467, "esperanzaM": 56.8707012830972 },
    { "edad": 32, "imssh": 370.321422034491, "imssm": 374.757482350297, "privada": 269.433002697323, "esperanzaH": 48.6720268791836, "esperanzaM": 55.9266279110083 },
    { "edad": 33, "imssh": 368.235520098446, "imssm": 372.762078422742, "privada": 267.446568157251, "esperanzaH": 47.8130754517663, "esperanzaM": 54.9821598924997 },
    { "edad": 34, "imssh": 366.08396701348, "imssm": 370.700220621117, "privada": 265.41803718372, "esperanzaH": 46.9572341606395, "esperanzaM": 54.037277915974 },
    { "edad": 35, "imssh": 363.86449889729, "imssm": 368.570594939474, "privada": 263.346079665192, "esperanzaH": 46.1043068996493, "esperanzaM": 53.0924941098482 },
    { "edad": 36, "imssh": 361.57527516925, "imssm": 366.370171206438, "privada": 261.231016897008, "esperanzaH": 45.2545520123303, "esperanzaM": 52.1472487210053 },
    { "edad": 37, "imssh": 359.214394552045, "imssm": 364.097386509238, "privada": 259.073143549824, "esperanzaH": 44.4082043995527, "esperanzaM": 51.2020348983465 },
    { "edad": 38, "imssh": 356.780286765181, "imssm": 361.750022479652, "privada": 256.872715030547, "esperanzaH": 43.5654757670718, "esperanzaM": 50.2568148265074 },
    { "edad": 39, "imssh": 354.270540105579, "imssm": 359.325671110499, "privada": 254.62998888628, "esperanzaH": 42.7265548789656, "esperanzaM": 49.3115506477264 },
    { "edad": 40, "imssh": 351.6829614081, "imssm": 356.821848234262, "privada": 252.343708901009, "esperanzaH": 41.8911872448378, "esperanzaM": 48.3662044587648 },
    { "edad": 41, "imssh": 349.015889554079, "imssm": 354.236849438498, "privada": 250.015648585912, "esperanzaH": 41.0599436130875, "esperanzaM": 47.4212130659212 },
    { "edad": 42, "imssh": 346.267517391305, "imssm": 351.567196112195, "privada": 247.646005427077, "esperanzaH": 40.232945277782, "esperanzaM": 46.4760548105977 },
    { "edad": 43, "imssh": 343.435569994208, "imssm": 348.811157223447, "privada": 245.235008497552, "esperanzaH": 39.4102915899367, "esperanzaM": 45.5311474990716 },
    { "edad": 44, "imssh": 340.51770052158, "imssm": 345.965954231748, "privada": 242.782870033247, "esperanzaH": 38.5920601934479, "esperanzaM": 44.5864346780724 },
    { "edad": 45, "imssh": 337.511905910524, "imssm": 343.029723280873, "privada": 240.289817694836, "esperanzaH": 37.7783072481814, "esperanzaM": 43.6422968179995 },
    { "edad": 46, "imssh": 334.416208592358, "imssm": 339.999674332588, "privada": 237.757503812102, "esperanzaH": 36.9694392490992, "esperanzaM": 42.6986590479428 },
    { "edad": 47, "imssh": 331.228064963825, "imssm": 336.872935561012, "privada": 235.18615338195, "esperanzaH": 36.1654560207316, "esperanzaM": 41.7554464551217 },
    { "edad": 48, "imssh": 327.946212955934, "imssm": 333.647280496899, "privada": 232.576900262803, "esperanzaH": 35.3666925010626, "esperanzaM": 40.8129927749344 },
    { "edad": 49, "imssh": 324.568073645165, "imssm": 330.319822269194, "privada": 229.930279028267, "esperanzaH": 34.5734416823229, "esperanzaM": 39.8712047338458 },
    { "edad": 50, "imssh": 321.092281373441, "imssm": 326.887451091865, "privada": 227.246715537344, "esperanzaH": 33.7859553414204, "esperanzaM": 38.9299890172619 },
    { "edad": 51, "imssh": 317.51605130253, "imssm": 323.348703701995, "privada": 224.525322513526, "esperanzaH": 33.0041125252121, "esperanzaM": 37.9900132381782 },
    { "edad": 52, "imssh": 313.837982057614, "imssm": 319.699601712338, "privada": 221.767687916859, "esperanzaH": 32.2284223447314, "esperanzaM": 37.0507765116573 },
    { "edad": 53, "imssh": 310.056115839163, "imssm": 315.938665623938, "privada": 218.974020800214, "esperanzaH": 31.4590169388935, "esperanzaM": 36.1128906836331 },
    { "edad": 54, "imssh": 306.168858467253, "imssm": 312.062466070326, "privada": 216.144449071978, "esperanzaH": 30.6959899815511, "esperanzaM": 35.1762078577771 },
    { "edad": 55, "imssh": 302.174228832862, "imssm": 308.066684771946, "privada": 213.280225259724, "esperanzaH": 29.9396991324896, "esperanzaM": 34.2409232026301 },
    { "edad": 56, "imssh": 298.071052329946, "imssm": 303.948531975256, "privada": 210.382469504845, "esperanzaH": 29.1904450555165, "esperanzaM": 33.307204539664 },
    { "edad": 57, "imssh": 293.857572130164, "imssm": 299.706121868251, "privada": 207.451099042771, "esperanzaH": 28.4481856172084, "esperanzaM": 32.3755168802814 },
    { "edad": 58, "imssh": 289.524251525183, "imssm": 295.33578318291, "privada": 204.475399306342, "esperanzaH": 27.7099784092274, "esperanzaM": 31.4456406589509 },
    { "edad": 59, "imssh": 285.069516865314, "imssm": 290.835581044107, "privada": 201.456778678927, "esperanzaH": 26.975956702449, "esperanzaM": 30.5179682436884 },
    { "edad": 60, "imssh": 280.491815163313, "imssm": 286.203140696247, "privada": 198.397658862262, "esperanzaH": 26.2464611297194, "esperanzaM": 29.5928381241425 },
    { "edad": 61, "imssh": 275.789533098524, "imssm": 281.432064153202, "privada": 195.300338194686, "esperanzaH": 25.5217605323175, "esperanzaM": 28.6689911927509 },
    { "edad": 62, "imssh": 270.962267964383, "imssm": 276.520690109604, "privada": 192.167964253371, "esperanzaH": 24.8022948246662, "esperanzaM": 27.7469473790372 },
    { "edad": 63, "imssh": 266.008499712539, "imssm": 271.466589196299, "privada": 189.001957313423, "esperanzaH": 24.0879616702615, "esperanzaM": 26.8268760711022 },
    { "edad": 64, "imssh": 260.928158877945, "imssm": 266.267057131122, "privada": 185.806361514521, "esperanzaH": 23.3792834398346, "esperanzaM": 25.9088963045849 },
    { "edad": 65, "imssh": 255.720964073825, "imssm": 260.921092917602, "privada": 182.584338003668, "esperanzaH": 22.6764724438596, "esperanzaM": 24.9935470992165 },
    { "edad": 66, "imssh": 250.387412663911, "imssm": 255.427740114115, "privada": 179.339787685134, "esperanzaH": 21.9798736073878, "esperanzaM": 24.0812590396168 },
    { "edad": 67, "imssh": 244.927759629042, "imssm": 249.785636844103, "privada": 176.07555632213, "esperanzaH": 21.2895492619979, "esperanzaM": 23.1723623640415 },
    { "edad": 68, "imssh": 239.3434680717, "imssm": 243.993969204848, "privada": 172.795439802866, "esperanzaH": 20.6058756222617, "esperanzaM": 22.2672955047278 },
    { "edad": 69, "imssh": 233.636875148202, "imssm": 238.052943889971, "privada": 169.503760362352, "esperanzaH": 19.9293539485389, "esperanzaM": 21.3665726350214 },
    { "edad": 70, "imssh": 227.810419665172, "imssm": 231.963039326093, "privada": 166.203609467795, "esperanzaH": 19.260127376096, "esperanzaM": 20.4707648362387 },
    { "edad": 71, "imssh": 221.866669721719, "imssm": 225.725491136999, "privada": 162.897898936311, "esperanzaH": 18.5982877677062, "esperanzaM": 19.580442885662 },
    { "edad": 72, "imssh": 215.810395311551, "imssm": 219.341516339229, "privada": 159.590772333076, "esperanzaH": 17.944330544567, "esperanzaM": 18.6961806572115 },
    { "edad": 73, "imssh": 209.646670964244, "imssm": 212.814221480856, "privada": 156.285226101965, "esperanzaH": 17.2984698355976, "esperanzaM": 17.8188514035816 },
    { "edad": 74, "imssh": 203.380699332779, "imssm": 206.144114083804, "privada": 152.984839304671, "esperanzaH": 16.6611786974883, "esperanzaM": 16.9492002450179 },
    { "edad": 75, "imssh": 197.018339930145, "imssm": 199.334942498307, "privada": 149.691522277569, "esperanzaH": 16.0325366565813, "esperanzaM": 16.0881513234813 },
    { "edad": 76, "imssh": 190.567450721768, "imssm": 192.391729596453, "privada": 146.407528964597, "esperanzaH": 15.4128483821539, "esperanzaM": 15.2368754786003 },
    { "edad": 77, "imssh": 184.030080514939, "imssm": 185.316786480285, "privada": 143.129794782385, "esperanzaH": 14.8006784026994, "esperanzaM": 14.3957796938055 },
    { "edad": 78, "imssh": 177.414469583408, "imssm": 178.11487895877, "privada": 139.859704543908, "esperanzaH": 14.1960406912377, "esperanzaM": 13.5658890235575 },
    { "edad": 79, "imssh": 170.728921745784, "imssm": 170.792015884056, "privada": 136.597889197168, "esperanzaH": 13.5987994626468, "esperanzaM": 12.7484264756594 },
    { "edad": 80, "imssh": 163.981969387942, "imssm": 163.355821189449, "privada": 133.344127467715, "esperanzaH": 13.0086247374091, "esperanzaM": 11.9448538639217 },
    { "edad": 81, "imssh": 157.180739041578, "imssm": 155.814145869546, "privada": 130.109021779632, "esperanzaH": 12.4249375527885, "esperanzaM": 11.1567235018053 },
    { "edad": 82, "imssh": 150.332877491983, "imssm": 148.175358222833, "privada": 126.916554501281, "esperanzaH": 11.8471153120188, "esperanzaM": 10.3856481117436 },
    { "edad": 83, "imssh": 143.445540503746, "imssm": 140.450190360816, "privada": 123.791168519973, "esperanzaH": 11.2745650792262, "esperanzaM": 9.63358845208609 },
    { "edad": 84, "imssh": 136.52403455169, "imssm": 132.649054022354, "privada": 120.760967510678, "esperanzaH": 10.7063678849409, "esperanzaM": 8.90234196588145 },
    { "edad": 85, "imssh": 129.571748108486, "imssm": 124.784942354411, "privada": 117.857267483231, "esperanzaH": 10.1414772148795, "esperanzaM": 8.19414216968182 },
    { "edad": 86, "imssh": 122.591228524039, "imssm": 116.871549863474, "privada": 115.113408858488, "esperanzaH": 9.57893089631006, "esperanzaM": 7.51110062634995 },
    { "edad": 87, "imssh": 115.582398772698, "imssm": 108.925929866328, "privada": 112.562780694213, "esperanzaH": 9.01757353747507, "esperanzaM": 6.85564303290008 },
    { "edad": 88, "imssh": 108.542853301676, "imssm": 101.092618678175, "privada": 110.237069435296, "esperanzaH": 8.45606364811508, "esperanzaM": 6.23017876468397 },
    { "edad": 89, "imssh": 101.467758691418, "imssm": 93.3777435029572, "privada": 108.163973343543, "esperanzaH": 7.89283281017836, "esperanzaM": 5.63709342458541 },
    { "edad": 90, "imssh": 94.3523540819474, "imssm": 85.8243506798405, "privada": 106.364451608752, "esperanzaH": 7.32591520301845, "esperanzaM": 5.07873076059905 },
    { "edad": 91, "imssh": 87.4565288016759, "imssm": 78.4752496003346, "privada": 104.89944167931, "esperanzaH": 6.78647185385547, "esperanzaM": 4.55743049945656 },
    { "edad": 92, "imssh": 80.7343622730167, "imssm": 71.3638980615769, "privada": 103.78409030672, "esperanzaH": 6.26688689074112, "esperanzaM": 4.0750848618855 },
    { "edad": 93, "imssh": 74.2127144375586, "imssm": 64.5203206176304, "privada": 102.974966275713, "esperanzaH": 5.76875072445391, "esperanzaM": 3.63363314042583 },
    { "edad": 94, "imssh": 67.9087852998087, "imssm": 57.9540967279839, "privada": 102.42096377211, "esperanzaH": 5.29323769183139, "esperanzaM": 3.23221196989013 },
    { "edad": 95, "imssh": 61.8161442272817, "imssm": 51.6741276928484, "privada": 102.067367387499, "esperanzaH": 4.83995897347977, "esperanzaM": 2.87065957800699 },
    { "edad": 96, "imssh": 55.9114152321562, "imssm": 45.6817321253854, "privada": 101.860676240171, "esperanzaH": 4.40812077906993, "esperanzaM": 2.54819058213932 },
    { "edad": 97, "imssh": 50.1650296683107, "imssm": 39.986820391418, "privada": 101.752755219682, "esperanzaH": 3.99619387638988, "esperanzaM": 2.2622243814379 },
    { "edad": 98, "imssh": 44.8590484930021, "imssm": 35.2588167322902, "privada": 101.704273414047, "esperanzaH": 3.60196171154467, "esperanzaM": 2.00749349261161 },
    { "edad": 99, "imssh": 39.6941495064325, "imssm": 30.7800596695333, "privada": 101.686641049883, "esperanzaH": 3.22149797346554, "esperanzaM": 1.77230616538126 },
    { "edad": 100, "imssh": 34.634676373057, "imssm": 26.4368865494467, "privada": 101.682009270326, "esperanzaH": 2.84853593385587, "esperanzaM": 1.52948147641267 }
  ];

  public pensionesLey73 = [
    { 'limInf': 0, 'limSup': 1, 'porcentCB': 0.8, 'porcentAnual': 0.00563 },
    { 'limInf': 1.01, 'limSup': 1.25, 'porcentCB': 0.7711, 'porcentAnual': 0.00814 },
    { 'limInf': 1.26, 'limSup': 1.5, 'porcentCB': 0.5818, 'porcentAnual': 0.01178 },
    { 'limInf': 1.51, 'limSup': 1.75, 'porcentCB': 0.4923, 'porcentAnual': 0.0143 },
    { 'limInf': 1.76, 'limSup': 2, 'porcentCB': 0.4267, 'porcentAnual': 0.01615 },
    { 'limInf': 2.01, 'limSup': 2.25, 'porcentCB': 0.3765, 'porcentAnual': 0.01756 },
    { 'limInf': 2.26, 'limSup': 2.5, 'porcentCB': 0.3368, 'porcentAnual': 0.01868 },
    { 'limInf': 2.51, 'limSup': 2.75, 'porcentCB': 0.3048, 'porcentAnual': 0.01958 },
    { 'limInf': 2.76, 'limSup': 3, 'porcentCB': 0.2783, 'porcentAnual': 0.02033 },
    { 'limInf': 3.01, 'limSup': 3.25, 'porcentCB': 0.256, 'porcentAnual': 0.02096 },
    { 'limInf': 3.26, 'limSup': 3.5, 'porcentCB': 0.237, 'porcentAnual': 0.02149 },
    { 'limInf': 3.51, 'limSup': 3.75, 'porcentCB': 0.2207, 'porcentAnual': 0.02195 },
    { 'limInf': 3.76, 'limSup': 4, 'porcentCB': 0.2065, 'porcentAnual': 0.02235 },
    { 'limInf': 4.01, 'limSup': 4.25, 'porcentCB': 0.1939, 'porcentAnual': 0.02271 },
    { 'limInf': 4.26, 'limSup': 4.5, 'porcentCB': 0.1829, 'porcentAnual': 0.02302 },
    { 'limInf': 4.51, 'limSup': 4.75, 'porcentCB': 0.173, 'porcentAnual': 0.0233 },
    { 'limInf': 4.76, 'limSup': 5, 'porcentCB': 0.1641, 'porcentAnual': 0.02355 },
    { 'limInf': 5.01, 'limSup': 5.25, 'porcentCB': 0.1561, 'porcentAnual': 0.02377 },
    { 'limInf': 5.26, 'limSup': 5.5, 'porcentCB': 0.1488, 'porcentAnual': 0.02398 },
    { 'limInf': 5.51, 'limSup': 5.75, 'porcentCB': 0.1422, 'porcentAnual': 0.02416 },
    { 'limInf': 5.76, 'limSup': 6, 'porcentCB': 0.1362, 'porcentAnual': 0.02433 },
    { 'limInf': 6.01, 'limSup': 10000, 'porcentCB': 0.13, 'porcentAnual': 0.0245 }
  ];

  public vacacionesLft = [
    { 'antig': 0, 'dias': 0 },
    { 'antig': 1, 'dias': 6 },
    { 'antig': 2, 'dias': 8 },
    { 'antig': 3, 'dias': 10 },
    { 'antig': 4, 'dias': 12 },
    { 'antig': 5, 'dias': 14 },
    { 'antig': 6, 'dias': 14 },
    { 'antig': 7, 'dias': 14 },
    { 'antig': 8, 'dias': 14 },
    { 'antig': 9, 'dias': 14 },
    { 'antig': 10, 'dias': 16 },
    { 'antig': 11, 'dias': 16 },
    { 'antig': 12, 'dias': 16 },
    { 'antig': 13, 'dias': 16 },
    { 'antig': 14, 'dias': 16 },
    { 'antig': 15, 'dias': 18 },
    { 'antig': 16, 'dias': 18 },
    { 'antig': 17, 'dias': 18 },
    { 'antig': 18, 'dias': 18 },
    { 'antig': 19, 'dias': 18 },
    { 'antig': 20, 'dias': 20 },
    { 'antig': 21, 'dias': 20 },
    { 'antig': 22, 'dias': 20 },
    { 'antig': 23, 'dias': 20 },
    { 'antig': 24, 'dias': 20 },
    { 'antig': 25, 'dias': 22 },
    { 'antig': 26, 'dias': 22 },
    { 'antig': 27, 'dias': 22 },
    { 'antig': 28, 'dias': 22 },
    { 'antig': 29, 'dias': 22 },
    { 'antig': 30, 'dias': 24 },
    { 'antig': 31, 'dias': 24 },
    { 'antig': 32, 'dias': 24 },
    { 'antig': 33, 'dias': 24 },
    { 'antig': 34, 'dias': 24 },
    { 'antig': 35, 'dias': 25 }
  ];

  public inversionSupuestos = {
    base: 0.005,
    medio: 0.01,
    optimista: 0.015
  }

  public gastos = [
    'Alimentación en casa (súper, abarrotes y productos de consumo)',
    'Hipoteca / Renta',
    'Colegiaturas',
    'Visitas a médicos y medicinas (gastos médicos menores)',
    'Mantenimiento de casa (jardín, gas, luz, agua, etc.)',
    'Transporte (gasolina, peaje, estacionamiento, taxi, etc.)',
    'Vestimenta y accesorios',
    'Tarjetas de crédito (gastos adicionales)',
    'Ahorro',
    'Gastos personales en el trabajo (comidas, etc.)',
    'Restaurantes y comidas familiares fuera de casa',
    'Apoyo a hijos (mesadas)',
    'Apoyo a familiares (padres, suegros, etc.)',
    'IMSS aportaciones voluntarias',
    'Inscripciones (gimnasio, clubes privados, etc.)',
    'Membresías',
    'Impuesto predial',
    'Mascotas',
    'Telefonía, internet, televisión por cable, servicios de streaming',
    'Cursos y talleres, libros, videojuegos, etc.',
    'Cine, teatro, museos, conciertos',
    'Festividades y celebraciones',
    'Suscripciones y certificaciones',
    'Vacaciones y fines de semana',
    'Tenencia autos',
    'Verificación autos',
    'Mantenimiento autos',
    'Póliza de gastos médicos mayores (GMM)',
    'Seguro autos',
    'Seguro de vida',
    'Otras propiedades'
  ];

  public expensesLabels: Expense[] = [
    { label: 'Alimentación en casa (súper, abarrotes y productos de consumo)', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Hipoteca / Renta', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Colegiaturas', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Visitas a médicos y medicinas (gastos médicos menores)', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Mantenimiento de casa (jardín, gas, luz, agua, etc.)', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Transporte (gasolina, peaje, estacionamiento, taxi, etc.)', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Vestimenta y accesorios', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Tarjetas de crédito (gastos adicionales)', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Ahorro', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Gastos personales en el trabajo (comidas, etc.)', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Restaurantes y comidas familiares fuera de casa', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Apoyo a hijos (mesadas)', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'Apoyo a familiares (padres, suegros, etc.)', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'IMSS aportaciones voluntarias', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'Inscripciones (gimnasio, clubes privados, etc.)', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Membresías', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'Impuesto predial', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Mascotas', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Telefonía, internet, televisión por cable, servicios de streaming', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'Cursos y talleres, libros, videojuegos, etc.', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Cine, teatro, museos, conciertos', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Festividades y celebraciones', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'Suscripciones y certificaciones', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Vacaciones y fines de semana', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Tenencia autos', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Verificación autos', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Mantenimiento autos', type: 'Necesario', value: 0, otherExpense: false },
    { label: 'Póliza de gastos médicos mayores (GMM)', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'Seguro autos', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Seguro de vida', type: 'Adicional', value: 0, otherExpense: false },
    { label: 'Otras propiedades', type: 'Estilo de vida', value: 0, otherExpense: false },
    { label: 'Otros (1)', type: 'Necesario', value: 0, otherExpense: true },
    { label: 'Otros (2)', type: 'Adicional', value: 0, otherExpense: true },
    { label: 'Otros (3)', type: 'Estilo de vida', value: 0, otherExpense: true }
  ];

  imss73(age: number, seniority: number, salary: number, incSalario: number, factorInteg: number, umaDiaria: number, factSp5anos: number, asignFamIMSS: number, edadJubilacion: number, ajustePension73: number): { table: any, pension: { normal: number; reducida: number; cAsignaciones: number; definitiva: number; porcentajeSueldoNominal: number; } } {
    let edad: number = age;
    let antiguedad: number = seniority;
    let tiempo: number = 0;
    let sueldo;
    let pastSueldo: number = salary;
    let uma: number;
    let sbcMax: number;
    let sbc: number;
    let sueldoInteg: number;
    let sbcPble: number;
    let prom: number[] = [];
    let derechos: number = 0;
    let vuma: number;
    let cb: number;
    let ia: number;
    let total: number;
    let principal: number;
    let ajuste: number;
    let pAjustada: number;
    let reduccion: number;
    let pReduccion: number;
    let asignaciones: number;
    let pAsignaciones: number;
    let lMax: number;
    let lMin: number;
    let pDefinitiva: number;
    let pensionDerechos: number;
    let porcentajeSueldo: number;
    let imss73Table: any[] = [{}];
    let pension = {
      normal: 0,
      reducida: 0,
      cAsignaciones: 0,
      definitiva: 0,
      porcentajeSueldoNominal: 0
    };
    do {
      sueldo = tiempo > 0 ? pastSueldo * (1 + incSalario) : salary;
      pastSueldo = sueldo;
      uma = umaDiaria * 30.4;
      sueldoInteg = sueldo * factorInteg;
      sbcMax = 25 * uma;
      sbc = Math.min(sueldoInteg, sbcMax);
      prom.push(sbc);
      sbcPble = 0 == 0 ? factSp5anos * sbc : this.average(prom);
      derechos = edad >= 60 && antiguedad >= 10 ? 1 : 0;
      vuma = Number((sbcPble / uma).toFixed(2));

      const _cb = this.pensionesLey73.filter(element => {
        const limInf = element.limInf;
        const limSup = element.limSup;
        if (vuma >= limInf && vuma <= limSup) {
          return { limInf, limSup }
        }
      })
      cb = _cb && _cb[0] && _cb[0].porcentCB ? _cb[0].porcentCB : 0.8;

      const _ia = this.pensionesLey73.filter(element => {
        const limInf = element.limInf;
        const limSup = element.limSup;
        if (vuma >= limInf && vuma <= limSup) {
          return { limInf, limSup }
        }
      });

      ia = _ia && _ia[0] && _ia[0].porcentAnual ? _ia[0].porcentAnual * Math.max((antiguedad - (500 / 52)), 0) : 0.00563 * Math.max((antiguedad - (500 / 52)), 0);

      total = cb + ia;
      principal = sbcPble * total;
      ajuste = ajustePension73;
      pAjustada = principal * ajuste * derechos;
      reduccion = Math.min(Math.max((65 - edad), 0) * 0.05, 1);
      pReduccion = pAjustada * (1 - reduccion) * derechos;
      asignaciones = asignFamIMSS;
      pAsignaciones = pReduccion * (1 + asignaciones);
      lMax = sbcPble * derechos;
      lMin = Math.max(pReduccion, uma) * derechos;
      pDefinitiva = Math.max(Math.min(pAsignaciones, lMax), lMin);
      pensionDerechos = pDefinitiva * derechos;
      porcentajeSueldo = pensionDerechos / sueldo;
      if (tiempo == 0) {
        imss73Table[0] = { edad, antiguedad, tiempo, sueldo, sueldoInteg, sbcMax, sbc, sbcPble, uma, derechos, vuma, cb, ia, total, principal, ajuste, pAjustada, reduccion, pReduccion, asignaciones, pAsignaciones, lMax, lMin, pDefinitiva, pensionDerechos, porcentajeSueldo };
      } else {
        imss73Table.push({ edad, antiguedad, tiempo, sueldo, sueldoInteg, sbcMax, sbc, sbcPble, uma, derechos, vuma, cb, ia, total, principal, ajuste, pAjustada, reduccion, pReduccion, asignaciones, pAsignaciones, lMax, lMin, pDefinitiva, pensionDerechos, porcentajeSueldo });
      }
      edad++;
      antiguedad++;
      tiempo++;
    } while (edad <= edadJubilacion);
    const _pension = this.searchInObjectArray(edadJubilacion, imss73Table, 'edad');
    pension.normal = _pension && _pension.pAjustada ? _pension.pAjustada : 0;
    pension.reducida = _pension && _pension.pReduccion ? _pension.pReduccion : 0;
    pension.cAsignaciones = _pension && _pension.pAsignaciones ? _pension.pAsignaciones : 0;
    pension.definitiva = _pension && _pension.pensionDerechos ? _pension.pensionDerechos : 0;
    pension.porcentajeSueldoNominal = _pension && _pension.porcentajeSueldo ? _pension.porcentajeSueldo : 0;
    return { table: imss73Table, pension };
  }

  imss97(age: number, seniority: number, salary: number, incSalario: number, factorInteg: number, umaDiaria: number, edadJubilacion: number, cuotaImss: number, saldoInicial: number, indiceRendNeto: number, asignFamIMSS: number): { table: any, pension: { normal: number; asignaciones: number; total: number; limiteMinimo: number; sueldo: number; porcentajeSueldoNominal: number; } } {
    let edad: number = age;
    let antiguedad: number = seniority;
    let tiempo: number = 0;
    let sueldo;
    let pastSueldo: number = salary;
    let uma: number;
    let sbcMax: number;
    let sbc: number;
    let sueldoInteg: number;
    let derechos: number = 0;
    let porcentajeAportacion: number = 0;
    let inicial;
    let pastInicial: number;
    let aportacion: number = 0;
    let pastAportacion: number = 0;
    let rendNeto: number = 0;
    let pastRendNeto: number = 0;
    let final: number = 0;
    let acumAport: number = 0;
    let acumRend: number = 0;
    let factor: number = 0;
    let asignaciones: number = 0;
    let pension1: number = 0;
    let pension2: number = 0;
    let pensionDerechos: number = 0;
    let limiteMinimo: number = 0;
    let porcentajeSueldo: number = 0;
    //////////
    let imss97Table: any[] = [{}];
    let pension = {
      normal: 0,
      asignaciones: 0,
      total: 0,
      limiteMinimo: 0,
      sueldo: 0,
      porcentajeSueldoNominal: 0
    };
    do {
      sueldo = tiempo > 0 ? pastSueldo * (1 + incSalario) : salary;
      pastSueldo = sueldo;
      uma = umaDiaria * 30.4;
      sueldoInteg = sueldo * factorInteg;
      sbcMax = 25 * uma;
      sbc = Math.min(sueldoInteg, sbcMax);
      derechos = edad >= 60 && antiguedad >= (1250 / 52) ? 1 : 0;
      porcentajeAportacion = cuotaImss;
      inicial = tiempo > 0 ? pastInicial : saldoInicial;
      aportacion = porcentajeAportacion * (sbc * 12);
      rendNeto = (inicial + (aportacion / 2)) * indiceRendNeto;
      final = inicial + aportacion + rendNeto;
      pastInicial = final;
      acumAport = pastAportacion + aportacion;
      pastAportacion = acumAport;
      acumRend = pastRendNeto + rendNeto;
      pastRendNeto = acumRend;
      factor = this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad') && this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').imssh ? this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').imssh : 0;
      asignaciones = asignFamIMSS;
      pension1 = (inicial / factor) / (1 + asignaciones);
      pension2 = pension1 * (1 + asignaciones);
      limiteMinimo = uma * derechos;
      pensionDerechos = Math.max(pension2, limiteMinimo) * derechos;
      porcentajeSueldo = pensionDerechos * sueldo;
      if (tiempo == 0) {
        imss97Table[0] = { edad, antiguedad, tiempo, sueldo, sueldoInteg, sbcMax, sbc, uma, derechos, porcentajeAportacion, inicial, aportacion, rendNeto, final, acumAport, acumRend, factor, pension1, asignaciones, pension2, pensionDerechos, limiteMinimo, porcentajeSueldo };
      } else {
        imss97Table.push({ edad, antiguedad, tiempo, sueldo, sueldoInteg, sbcMax, sbc, uma, derechos, porcentajeAportacion, inicial, aportacion, rendNeto, final, acumAport, acumRend, factor, pension1, asignaciones, pension2, pensionDerechos, limiteMinimo, porcentajeSueldo });
      }
      edad++;
      antiguedad++;
      tiempo++;
    } while (edad <= edadJubilacion);
    const _pension = this.searchInObjectArray(edadJubilacion, imss97Table, 'edad') ? this.searchInObjectArray(edadJubilacion, imss97Table, 'edad') : {
      pension1: 0, asignaciones: 0, limiteMinimo: 0, sueldo: 0

    };

    pension.normal = _pension.pension1;
    pension.asignaciones = _pension.asignaciones * pension.normal;
    pension.total = pension.normal + pension.asignaciones;
    pension.limiteMinimo = _pension.limiteMinimo;
    pension.sueldo = _pension.sueldo;
    pension.porcentajeSueldoNominal = pension.total / pension.sueldo;
    return { table: imss97Table, pension };
  }

  inversiones(age: number, seniority: number, salary: number, incSalario: number, edadJubilacion: number, otherInvestments: number, sobreEleccionPersonal: number) {
    let edad: number = age;
    let antiguedad: number = seniority;
    let tiempo: number = 0;
    let sueldo;
    let pastSueldo: number = salary;
    let invInicial: number = 0;
    let ahorro: number = 0;
    let ahorroAcum: number = 0;
    let rendimineto: number = 0;
    let invFinal: number = 0;
    let factor: number = 0;
    let pension: number = 0;
    let capitalAcum: number = 0;
    let rendAcum: number = 0;
    //////////////
    let inversionesTable: any[] = [{}];
    let inversiones = {
      total: 0,
      pension: 0,
      porcentajeSueldo: 0
    }
    do {
      sueldo = tiempo > 0 ? pastSueldo * (1 + incSalario) : salary;
      pastSueldo = sueldo;
      ahorroAcum += ahorro;
      invInicial = tiempo > 0 ? invFinal : otherInvestments;
      rendimineto = (invInicial + (ahorro / 2)) * this.inversionSupuestos.base;
      invFinal = invInicial + ahorro + rendimineto;
      factor = this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad') && this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada ? this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada : 0;
      pension = invInicial / factor;
      capitalAcum = ahorroAcum + otherInvestments;
      rendAcum += rendimineto;
      if (tiempo == 0) {
        inversionesTable[0] = { edad, antiguedad, tiempo, sueldo, invInicial, rendimineto, invFinal, factor, pension, capitalAcum, rendAcum };
      } else {
        inversionesTable.push({ edad, antiguedad, tiempo, sueldo, invInicial, rendimineto, invFinal, factor, pension, capitalAcum, rendAcum });
      }
      edad++;
      antiguedad++;
      tiempo++;
    } while (tiempo <= 40);
    const _inversiones = this.searchInObjectArray(edadJubilacion - 1, inversionesTable, 'edad') ? this.searchInObjectArray(edadJubilacion - 1, inversionesTable, 'edad') : {
      invInicial: 0
    };
    inversiones.total = _inversiones.invInicial;
    inversiones.pension = inversiones.total / sobreEleccionPersonal;
    inversiones.porcentajeSueldo = inversiones.pension / (this.searchInObjectArray(edadJubilacion, inversionesTable, 'edad') && this.searchInObjectArray(edadJubilacion, inversionesTable, 'edad').sueldo ? this.searchInObjectArray(edadJubilacion, inversionesTable, 'edad').sueldo : 0);
    return { table: inversionesTable, inversiones };
  }

  ahorro(age: number, seniority: number, salary: number, incSalario: number, edadJubilacion: number, save: number, type: string): any {
    let edad: number = age;
    let antiguedad: number = seniority;
    let tiempo: number = 0;
    let sueldo;
    let pastSueldo: number = salary;
    let ahorro: number = 0;
    let porcentajeAportacion: number = 0;
    let pastPorcentajeAportacion: number = 0;
    let inicial: number = 0;
    let final: number = 0;
    let pastFinal: number = 0;
    let rendim: number = 0;
    let factor: number = 0;
    let pension: number = 0;
    let capitalAcum: number = 0;
    let pastCapitalAcum: number = 0;
    let rendAcum: number = 0;
    let pastRendAcum: number = 0;

    let ahorroArray: any[] = [{}];
    let miAhorro = {
      capital: 0,
      intereses: 0,
      sueldo: 0
    }
    do {
      sueldo = tiempo > 0 ? pastSueldo * (1 + incSalario) : salary;
      pastSueldo = sueldo;
      porcentajeAportacion = tiempo == 0 ? (save / 12) / sueldo : pastPorcentajeAportacion;
      pastPorcentajeAportacion = porcentajeAportacion;
      ahorro = tiempo > 0 ? (sueldo * 12) * porcentajeAportacion : save;
      inicial = tiempo > 0 ? pastFinal : 0;
      rendim = (inicial + (ahorro / 2)) * this.inversionSupuestos[type == 'base' || type == 'medio' || type == 'optimista' ? type : 'base'];
      final = inicial + ahorro + rendim;
      pastFinal = final;
      factor = this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad') && this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada ? this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada : 0;
      pension = inicial / factor;
      capitalAcum = tiempo > 0 ? pastCapitalAcum + ahorro : ahorro;
      pastCapitalAcum = capitalAcum;
      rendAcum = tiempo > 0 ? pastRendAcum + rendim : rendim;
      pastRendAcum = rendAcum;

      if (tiempo == 0) {
        ahorroArray[0] = { edad, antiguedad, tiempo, sueldo, porcentajeAportacion, inicial, ahorro, rendim, final, factor, pension, capitalAcum, rendAcum };
      } else {
        ahorroArray.push({ edad, antiguedad, tiempo, sueldo, porcentajeAportacion, inicial, ahorro, rendim, final, factor, pension, capitalAcum, rendAcum });
      }
      edad++;
      antiguedad++;
      tiempo++;
    } while (tiempo <= 40);

    const _pension = this.searchInObjectArray(edadJubilacion, ahorroArray, 'edad') ? this.searchInObjectArray(edadJubilacion, ahorroArray, 'edad') : {
      capitalAcum: 0,
      rendAcum: 0,
      sueldo: 0
    };
    miAhorro.capital = _pension.capitalAcum;
    miAhorro.intereses = _pension.rendAcum;
    miAhorro.sueldo = _pension.sueldo;
    return { miAhorro, table: ahorroArray };
  }


  individual(age: number, seniority: number, salary: number, incSalario: number, edadJubilacion: number, ahorroIndividual: number, tasaInteres: number): any {
    let edad: number = age;
    let antiguedad: number = seniority;
    let tiempo: number = 0;
    let sueldo;
    let pastSueldo: number = salary;
    let ahorro: number = 0;
    let porcentajeAportacion: number = 0;
    let pastPorcentajeAportacion: number = 0;
    let inicial: number = 0;
    let final: number = 0;
    let pastFinal: number = 0;
    let rendim: number = 0;
    let factor: number = 0;
    let pension: number = 0;
    let capitalAcum: number = 0;
    let pastCapitalAcum: number = 0;
    let rendAcum: number = 0;
    let pastRendAcum: number = 0;
    let ahorroArray: any[] = [];
    let miAhorro = {
      capital: 0,
      intereses: 0,
      sueldo: 0
    }
    do {
      sueldo = tiempo > 0 ? pastSueldo * (1 + incSalario) : salary;
      pastSueldo = sueldo;
      porcentajeAportacion = tiempo == 0 ? ahorroIndividual : pastPorcentajeAportacion;
      pastPorcentajeAportacion = porcentajeAportacion;
      ahorro = (sueldo * 12) * porcentajeAportacion;
      inicial = tiempo > 0 ? pastFinal : 0;
      rendim = tiempo == 0 ? (inicial + (ahorro / 2)) * tasaInteres : (inicial + (ahorro / 2)) * this.inversionSupuestos.base;
      final = inicial + ahorro + rendim;
      pastFinal = final;
      factor = this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad') && this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada ? this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada : 0;
      pension = inicial / factor;
      capitalAcum = tiempo > 0 ? pastCapitalAcum + ahorro : ahorro;
      pastCapitalAcum = capitalAcum;
      rendAcum = tiempo > 0 ? pastRendAcum + rendim : rendim;
      pastRendAcum = rendAcum;
      ///////
      ahorroArray.push({ edad, antiguedad, tiempo, sueldo, porcentajeAportacion, inicial, ahorro, rendim, final, factor, pension, capitalAcum, rendAcum });
      edad++;
      antiguedad++;
      tiempo++;
    } while (tiempo <= 40);

    const _pension = this.searchInObjectArray(edadJubilacion, ahorroArray, 'edad') ? this.searchInObjectArray(edadJubilacion, ahorroArray, 'edad') : {
      capitalAcum: 0,
      rendAcum: 0,
      sueldo: 0
    };
    miAhorro.capital = _pension.capitalAcum;
    miAhorro.intereses = _pension.rendAcum;
    miAhorro.sueldo = _pension.sueldo;
    return { miAhorro, table: ahorroArray };
  }

  plan(age: number, seniority: number, salary: number, incSalario: number, factorInteg: number, umaDiaria: number, edadJubilacion: number, ahorrasParaJubilarte: boolean, ahorroIndividual: number, saldoInicial: number, tasaInteres: number, planJubilacion: boolean, planEquivaleEnIL: number, sueldoAConsiderar: number, integracionILPorcentaje: number, matchDeLaEmpresa: number, sueldoIntegrado: number, maximoEmpresa: number): { table: any, pension: { plan: number, empleado: number, total: number, pensionMinima: number, porcentajeSueldoNominal: number } } {
    let edad: number = age;
    let antiguedad: number = seniority;
    let tiempo: number = 0;
    let sueldo;
    let pastSueldo: number = salary;
    let uma: number;
    let sueldoInteg: number;
    let derechos: number = 0;
    let porcentajeAportacion: number = 0;
    let inicial;
    let pastInicial: number;
    let aportacion: number = 0;
    let pastAportacion: number = 0;
    let rendNeto: number = 0;
    let pastRendNeto: number = 0;
    let final: number = 0;
    let acumAport: number = 0;
    let acumRend: number = 0;
    let factor1: number = 0;
    let asignaciones: number = 0;
    let pension1: number = 0;
    let pension2: number = 0;
    let pensionDerechos: number = 0;
    let limiteMinimo: number = 0;
    let porcentajeSueldo1: number = 0;
    let porcentajeSueldo2: number = 0;
    let factorPlan: number = 0;
    let il: number = 0;
    let factor2: number = 0;
    let minima: number = 0;
    let plan: any[] = [{}];
    let pension = {
      plan: 0,
      empleado: 0,
      total: 0,
      pensionMinima: 0,
      porcentajeSueldoNominal: 0
    };
    do {
      sueldo = salary;
      pastSueldo = sueldo;
      uma = umaDiaria * 30.4;
      sueldoInteg = sueldoIntegrado;
      derechos = edad >= 55 && antiguedad >= 10 ? 1 : 0;
      porcentajeAportacion = ahorrasParaJubilarte ? Math.min(ahorroIndividual, matchDeLaEmpresa, maximoEmpresa) : 0;
      inicial = tiempo > 0 ? pastInicial : saldoInicial;
      aportacion = porcentajeAportacion * (sueldo * 12);
      rendNeto = (inicial + (aportacion / 2)) * tasaInteres;
      final = inicial + aportacion + rendNeto;
      pastInicial = final;
      acumAport = pastAportacion + aportacion;
      pastAportacion = acumAport;
      acumRend = pastRendNeto + rendNeto;
      pastRendNeto = acumRend;
      factor1 = this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad') && this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada ? this.searchInObjectArray(edad, this.esperanzaDeVida, 'edad').privada : 0;
      pension1 = inicial / factor1;
      porcentajeSueldo1 = pension1 / sueldo;
      factorPlan = !planJubilacion ? 0 : planEquivaleEnIL;
      il = !planJubilacion ? 0 : sueldoInteg * (3 + (2 / 3) * antiguedad);
      factor2 = factor1;
      pension2 = (factorPlan * il) / factor2;
      minima = il / factor2;
      pensionDerechos = Math.max(pension2, minima) * derechos;
      porcentajeSueldo2 = pensionDerechos / sueldo;
      if (tiempo == 0) {
        plan[0] = { edad, antiguedad, tiempo, sueldo, sueldoInteg, uma, derechos, porcentajeAportacion, inicial, aportacion, rendNeto, final, acumAport, acumRend, factor1, pension1, asignaciones, limiteMinimo, porcentajeSueldo1, factorPlan, il, factor2, pension2, minima, pensionDerechos, porcentajeSueldo2 };
      } else {
        plan.push({ edad, antiguedad, tiempo, sueldo, sueldoInteg, uma, derechos, porcentajeAportacion, inicial, aportacion, rendNeto, final, acumAport, acumRend, factor1, pension1, asignaciones, limiteMinimo, porcentajeSueldo1, factorPlan, il, factor2, pension2, minima, pensionDerechos, porcentajeSueldo2 });
      }
      edad++;
      antiguedad++;
      tiempo++;
    } while (tiempo <= 40);
    const _pension = this.searchInObjectArray(edadJubilacion, plan, 'edad') ? this.searchInObjectArray(edadJubilacion, plan, 'edad') : {
      pensionDerechos: 0,
      pension1: 0,
      minima: 0,
      sueldo: 0
    };
    pension.plan = _pension.pensionDerechos;
    pension.empleado = _pension.pension1;
    pension.total = pension.plan + pension.empleado;
    pension.pensionMinima = _pension.minima;
    pension.porcentajeSueldoNominal = pension.total / _pension.sueldo;
    //console.log({ table: plan, pension });
    return { table: plan, pension };
  }

  average(arreglo: number[]): number {
    let suma: number = 0
    arreglo.forEach(element => {
      suma += element;
    });
    return suma / arreglo.length;
  }

  searchInObjectArray(value: any, arreglo: any[], key: string): any {
    return arreglo[arreglo.map(element => { return element[key] }).indexOf(value)];
  }


}



// WEBPACK FOOTER //
// ./src/providers/retirement-tools/consts/consts.ts